import PowWorker from '../workers/pow.worker.ts?worker';

export interface PowProgress {
  hashesPerSec: number;
  elapsedMs: number;
}

export interface PowResult {
  nonce: string;
  hash: string;
  durationMs: number;
}

export function solvePow(
  challenge: string,
  difficulty: number,
  onProgress?: (p: PowProgress) => void,
): Promise<PowResult> {
  return new Promise((resolve, reject) => {
    const w = new PowWorker();
    w.onmessage = (ev: MessageEvent) => {
      const msg = ev.data as
        | { type: 'progress'; hashesPerSec: number; elapsedMs: number }
        | { type: 'done'; nonce: string; hash: string; durationMs: number }
        | { type: 'error'; message: string };
      if (msg.type === 'progress') onProgress?.(msg);
      else if (msg.type === 'done') {
        w.terminate();
        resolve({ nonce: msg.nonce, hash: msg.hash, durationMs: msg.durationMs });
      } else {
        w.terminate();
        reject(new Error(msg.message));
      }
    };
    w.onerror = (err) => {
      w.terminate();
      reject(new Error(err.message));
    };
    w.postMessage({ type: 'solve', challenge, difficulty });
  });
}
